export default __webpack_public_path__ + "static/media/btn-zeroback-stop-se_se@3x.b1f50a77.png";